/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable no-console */

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Sidebar from "../Components/Sidebars/main";
import ActionBarComponent from "../Components/common/ActionBarComponent";
import NavBar from "../Components/Navbars/main";
import ChatPageLayout from "../Components/AChatWindow/components/ChatPageLayout";
import TreatmentFooter from "../Components/TreatmentPage/components/treatmentFooter";
import ChatIcon from "../assets/chat-page-icon.svg";
import { fetchPageObject, fetchShakespeareStatus, getCaseId } from "../Utils/helper";
// import Footer from "../Components/common/footer";

const NewChatPage = () => {
  const unreadCounts = useSelector((state) => state.chat2.unreadCounts);
  const dispatch = useDispatch();
  const caseId = getCaseId();
  const [pageObject, setPageObject] = useState(null);

  useEffect(() => {
    if (caseId && !pageObject) {
      fetchPageObject(caseId, 30).then((data) => {
        setPageObject(data);
      });
    }
  }, [caseId, pageObject]);

  const totalUnread = Object.values(unreadCounts).reduce((sum, count) => sum + count, 0);

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    // sending page ids directly now.
    fetchShakespeareStatus(getCaseId(), 30, dispatch);
  }, [dispatch]);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);

  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container overflow-hidden">
          <NavBar flaggedPageName="30" chatCount={totalUnread} />
          <ActionBarComponent
            // src="/BP_resources/images/icon/chat-logo-icon.svg"
            src={ChatIcon}
            page_name={pageObject?.name}
            pageObj={pageObject}
            isChecklist={pageObject?.PageChklst || false}
          />

          {/* Full Page Chat Interface */}
          <div
            className="TreatmentPage-main-container invisible-scrollbar  m-t-5"
            style={{ padding: 0, height: "", scrollbarWidth: "none" }}
          >
            <ChatPageLayout />
          </div>
        </div>
      </div>
      <TreatmentFooter />
    </>
  );
};

export default NewChatPage;
